// Marca Growthly — URL única reutilizable
export const GROWTHLY_LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/24nvud2Z1jv8nGAPwkN6Es/Captura_de_pantalla_2026-04-28_a_las_19.45.31.png'

export const COMPANY_NAME = 'Growthly Corporation Systems'
export const PANEL_NAME = 'Marketing Manager Panel'

export const CURRENT_USER = {
  name: 'Ivana Jovanoska Risteska',
  role: 'Marketing Manager',
  company: COMPANY_NAME,
}
